import { h, Fragment } from 'preact';
import clsx from 'clsx';

import MobileMenuList from './mobile-menu-list';
import { getBannerMedia } from './utils';

const MobileSubMenuItems = ({
  megaMenus,
  megaMenusBanners,
  activeSubMenuLink = false,
  isVoyagesLayout,
  vShowShopAllCta
}) => {

  const BANNER_TITLE_CLASS = "font-13 text-black block w-fit mt-2.5 mx-auto"
  const V_BANNER_TEXT_CLASSES = 'text-[12px] font-light leading-[16px] tracking-[1.2px] font-sackers'
  const V_BANNER_LINK_CLASS = 'absolute w-full bottom-5 transform -translate-x-1/2 uppercase before:hidden before:content-[]'
  const V_BANNER_P_CLASS = 'absolute w-full bottom-5 uppercase'

  const linkNotHash = activeSubMenuLink?.url !== '#'

  const isShopAllCtaEnabled = () => {
    if (isVoyagesLayout) {
      return vShowShopAllCta;
    }
    return linkNotHash
  }

  const ShopAllCtaHolder = () => (
    <div className="p-5 order-[20] w-full">
      <div className="bg-cream-grey text-center w-full pt-[18px] pb-5">
        <a
          href={activeSubMenuLink.url}
          className="text-black cta-small uppercase underline"
        >
          {window.TMW?.Strings?.header?.shopAll}{' '}
          {isVoyagesLayout ? 'voyages' : activeSubMenuLink?.title}
        </a>
      </div>
    </div>
  );

  const getBannerTitleColorClass = (color) => color ? `text-${color}` : 'text-white';

  return (
    <>
      <div className="flex flex-col items-start justify-start w-full">
        {megaMenus?.length > 0 &&
          megaMenus?.map((menuList) => {
            const isFeatured = menuList.handle === 'Featured';
            if (isFeatured) {
              return (
                <div
                  key={menuList.handle}
                  className="p-5 w-full"
                  style={{ order: menuList.index + 30 }}
                >
                  <p
                    className={`font-14-bold ${
                      isVoyagesLayout ? 'text-white' : 'text-black'
                    }  mb-5`}
                  >
                    {menuList.handle}
                  </p>
                  <ul>
                    {menuList.links.length > 0 &&
                      menuList.links.map((link) => (
                        <li key={link.label} className="mb-5">
                          <a
                            href={link.url}
                            className={`font-14 ${
                              isVoyagesLayout ? 'text-white' : 'text-charcoal'
                            }`}
                          >
                            {link.label}
                          </a>
                        </li>
                      ))}
                  </ul>
                </div>
              );
            }
            return (
              <MobileMenuList
                menuList={menuList}
                key={menuList.handle}
                isVoyagesLayout={isVoyagesLayout}
              />
            );
          })}
        {isShopAllCtaEnabled() && <ShopAllCtaHolder />}
      </div>
      <div
        className={clsx(
          'flex flex-col items-start justify-start',
          isVoyagesLayout ? 'relative' : 'px-5 pt-5',
        )}
      >
        {megaMenusBanners?.length > 0 &&
          megaMenusBanners?.map((banner) => (
            <div
              key={banner.title}
              className={clsx(
                'w-full text-center',
                banner.media || banner.mediaMobile ? '' : 'h-[58px]',
                isVoyagesLayout ? 'relative font-sackers' : 'pb-10',
              )}
            >
              {banner.url && (
                <a
                  href={banner.url}
                  className={clsx(
                    'block link-unstyled',
                  )}
                  target={banner.new_tab ? '_blank' : ''}
                  rel="noreferrer"
                >
                  {getBannerMedia({
                    ...banner,
                    isVoyages: isVoyagesLayout,
                    isDesktop: false,
                  })}
                </a>
              )}
              {!banner.url &&
                getBannerMedia({
                  ...banner,
                  isVoyages: isVoyagesLayout,
                  isDesktop: false,
                })}
              {banner.title && banner.url && (
                <a
                  href={banner.url}
                  target={banner.new_tab ? '_blank' : ''}
                  className={clsx(
                    'underline',
                    isVoyagesLayout
                      ? `${V_BANNER_LINK_CLASS}
                         ${V_BANNER_TEXT_CLASSES}
                         ${getBannerTitleColorClass(banner.title_color)}`
                      : `${BANNER_TITLE_CLASS}`,
                  )}
                  rel="noreferrer"
                >
                  {banner.title}
                </a>
              )}
              {banner.title && !banner.url && (
                <p
                  className={`
                    ${
                      isVoyagesLayout
                    ? `w-full ${V_BANNER_TEXT_CLASSES}
                        ${V_BANNER_P_CLASS}
                        ${getBannerTitleColorClass(banner.title_color)}`
                        : `${BANNER_TITLE_CLASS}`
                    }`}
                >
                  {banner.title}
                </p>
              )}
            </div>
          ))}
      </div>
    </>
  );
};

export default MobileSubMenuItems;
